import MyInput from '../../components/ui/MyInput';
import deleteX from '../../assets/img/deleteX.svg';
import { useEffect, useState } from 'react';
import PrimaryButton from '../../components/ui/PrimaryButton';
import {
    SVG_Add_Square_Bold,
    SVG_Traffic_Bold,
    SVG_Trash_Bin_2_Bold,
    SVG_Trash_Bin_2_Linear,
    SVG_Trash_Bin_2_Outline,
    SVG_Trash_Bin_Minimalistic_2_Bold,
} from '@dev-mobligo/iconpack';
import { useDispatch } from 'react-redux';
import systemSlice from '../../redux/systemSlice';
import { useNavigate } from 'react-router-dom';
import allTabs from '../DashboardTabs';
import LayeredDashboardHeader from '../LayeredDashboardHeader';
import CreateAction from '../../components/operational/createAction';
import useCustomNavigate from '../../components/operational/goBack';
import SecondaryButton from '../../components/ui/SecondaryButton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { emailValidator } from '../../helper/Validators';
const Staff = ({ tab }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const goBack = useCustomNavigate(tab)
    const [staff, setStaff] = useState([]);
    const [staffEmail, setStaffEmail] = useState('');


    const getStaff = async () => {

        const response = await CreateAction({
            method: 'get',
            path: `/staff`,
            showPreLoader: true,
            isFileUploading: false

        });

        if (response?.error) {
            return navigate('/dashboard/');
        }
        setStaff(response?.result?.resultData || [])

    }
    const addStaff = async () => {
        if (!emailValidator(staffEmail)) {
            dispatch(systemSlice.actions.setToastError({ detail: "Lütfen geçerli bir email giriniz." }))
            return
        }
        const response = await CreateAction({
            method: 'post',
            path: `/staff`,
            showPreLoader: true,
            isFileUploading: false,
            data: { staffEmail }
        });

        if (response.error) return
        const newStaff = response?.result?.resultData
        setStaff(prevState => [newStaff, ...prevState])
        setStaffEmail("")

    }


    const deleteStaff = async (s) => {
        const response = await CreateAction({
            method: 'delete',
            path: `/staff/` + s?.id,
            showPreLoader: true,
            isFileUploading: false,
            data: {}
        });
        if (response.error) return
        setStaff(prevState => prevState.filter(prevStaff => prevStaff?.id !== s?.id))
    }


    useEffect(() => {
        getStaff()
    }, [])


    return (
        <>
            <LayeredDashboardHeader tab={tab} >

            </LayeredDashboardHeader>
            <div className='w-full h-[calc(100dvh-70px)] overflow-auto scrollbar-y-visible'>
                <div>
                    <div className="p-[20px] flex items-center justify-center 2xl:p-[40px] flex-col max-w-[1120px] mx-auto">
                        <div className="bg-white p-[20px] rounded-[10px] 2xl:p-[40px] max-w-[1120px] w-[100%]">
                            <div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div className="text-[#5E5873] text-[18px] font-semibold">Ayarlar</div>

                                </div>
                            </div>
                            <div className="mt-[40px]">
                                <div className="text-[#5E5873] block mb-[5px] text-[14px] font-semibold">Personeller</div>
                                <div className="text-[#8A92A6] block mb-[5px] text-[14px] font-medium">
                                    Personelin <a href="https://mobligo.com" target="_blank" className='text-[#7059ef]'>mobligo</a> hesabının olması gerekmektedir.
                                </div>
                                <div className="flex gap-[20px] flex-col justify-start">
                                    <div className="grid clearLabel ">

                                        <input
                                            placeholder="Personel Email Adresi"
                                            isRequired={true}
                                            value={staffEmail}
                                            onChange={e => {
                                                setStaffEmail(e.target.value);
                                            }}
                                            className="bg-white border h-[45px] text-gray-900 text-sm rounded-[5px]
                    border-[#E3E8EF]  focus:outline-none focus:ring-[#7059EF] focus:border-[#7059EF] block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 border-slate-300 py-[30px] px-[25px]"
                                        />
                                    </div>
                                    <div className="flex justify-center">
                                        <PrimaryButton
                                            onClick={() => addStaff()}
                                            value={
                                                <>
                                                    <SVG_Add_Square_Bold className={'fill-white'}></SVG_Add_Square_Bold>
                                                    Personel Ekle
                                                </>
                                            }
                                        />
                                    </div>
                                </div>
                                <div>

                                    <DataTable cellClassName={"text-start"} value={staff?.sort((a, b) => {
                                        return a?.name?.localeCompare(b?.name)
                                    })} tableStyle={{ minWidth: '50rem' }}>
                                        <Column field="name" header="İsim"></Column>
                                        <Column field="email" header="Email"></Column>
                                        <Column field="phone" header="Telefon Numarası"></Column>

                                        <Column header="İşlemler" body={(s) => {
                                            return (
                                                <SecondaryButton confirmationMessage='Personal kaldırılacaktır. Emin misiniz?' classes={`${s?.isOwner ? "hidden pointer-events-none user-select-none" : ""} !w-auto !h-auto !border-[0px] !border-transparent`} onClick={() => deleteStaff(s)} value={<SVG_Trash_Bin_2_Linear className={'stroke-[#E23D47] fill-[#E23D47]'}></SVG_Trash_Bin_2_Linear>}>

                                                </SecondaryButton>
                                            )
                                        }}></Column>
                                    </DataTable>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>

    );
};

export default Staff;
